import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Script} from '../../../../scripts-repository/entities/script';
import {Patient} from '../../../../patient-repository/entities/patient';
import {PatientService} from '../../../../patients/services/patient.service';
import {FilesRepositoryService} from '../../../../files-repository/files-repository.service';
import {Subscription} from 'rxjs';
import {PatientEvent, PatientEventsService} from '../../../../patients/services/patient-events.service';

@Component({
    selector: 'app-script-widget',
    templateUrl: './script-widget.component.html',
    styleUrls: ['./script-widget.component.scss'],
    standalone: false
})
export class ScriptWidgetComponent implements OnInit, OnDestroy {

  @Input() script: Script;
  printing = false;
  private filesRepositorySubscription: Subscription;

  constructor(
    private patientService: PatientService,
    private patientEventService: PatientEventsService,
    private filesRepository: FilesRepositoryService
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.filesRepositorySubscription) { this.filesRepositorySubscription.unsubscribe(); }
  }


  get patientId(): number {
    return this.patientService.currentPatient.id;
  }

  get patient(): Patient {
    return this.patientService.currentPatient;
  }

  get confirmationMessage(): string {
    return 'Are you sure you wish to print this script?';
  }

  print(id: number) {
    this.printing = true;
    this.filesRepositorySubscription = this.filesRepository.getUrl('script', id, this.patientId).subscribe(
      url => {
        window.open(url, '_blank');
        this.printing = false;
        this.patientEventService.emitEvent(new PatientEvent('scripts_updated'));
      }, error => {
        console.error(error);
        this.printing = false;
      });
  }
}
